import axios from '@/utils/request';

export default {
    getJobs(params) {
        return axios.get('/web/job/list', { params });
    },
    getAllJobs(params) {
        // 管理员获取所有公司的职位
        return axios.get('/web/job/all', { params });
    },
    getJobStats() {
        // 获取职位统计信息
        return axios.get('/web/job/stats');
    },
    createJob(data) {
        return axios.post('/web/job', data);
    },
    updateJob(data) {
        return axios.put('/web/job', data);
    },
    deleteJob(id) {
        return axios.delete(`/web/job/${id}`);
    },
    getJob(id) {
        return axios.get(`/web/job/${id}`);
    },
    getJobApplications(id) {
        return axios.get(`/web/job/${id}/applications`);
    }
};
